<template>
	<div class="table-responsive">
		<table class="comments">
			<thead>
				<tr>
					<th>Group</th>
					<th>Key</th>
					<th>Original</th>
					<th>Translation Status</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="translation in translationList">
					<td>{{ translation.group }}</td>
					<td>{{ translation.key }}</td>
					<td>{{ translation.original }}</td>
					<td class="nowrap">
						<ul class="translation-languages">
							<li :class="[translation.translations.hasOwnProperty(language.locale) ? 'badge-success' : 'badge-danger']" :title="[translation.translations.hasOwnProperty(language.locale) ? 'Translation in place' : 'Missing translation']"
								class="badge"
								v-for="language in availableLanguages">{{ language.locale }}
							</li>
						</ul>
					</td>
					<td class="nowrap">
						<a @click="editTranslation(translation)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('site_content.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
						<a @click="deleteTranslation(translation)" class="btn btn-icon btn-danger" href="#" title="Delete" v-show="userRoles.includes('site_content.delete') && !userRoles.includes('users.translator')"><i class="fas fa-fw fa-trash"></i></a>
					</td>
				</tr>
			</tbody>
		</table>

		<modal @close="closeEditModal" v-show="isEditModalVisible">
			<template slot="header">
				<h4 class="modal-title">Edit Translation</h4>
			</template>
			<template slot="body">
				<div class="flex box start">
					<div class="form-group six-md">
						<label for="group">Group</label>
						<vue-select
								:options="groups"
								id="group"
								name="group"
								taggable
								v-model="selectedTranslation.group">
						</vue-select>
					</div>
					<div class="form-group six-md">
						<label for="key">Key</label>
						<input id="key" type="text" v-model="selectedTranslation.key">
					</div>
				</div>
				<div class="card mt-1 mb-0">
					<header class="card-header language-list">
						<lang-selector></lang-selector>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="value">Text</label>
							<input id="value" type="text" v-model="selectedTranslation[clickedLang].value">
						</div>
					</div>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeEditModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a @click="saveTranslation" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from "../Modal/DefaultModal.vue";
	import {eventBus} from '../../app';
	import VueSelect from '../../../../node_modules/vue-select';
	import Errors from '../../Utils/Errors.js';

	export default {
		components: {
			modal,
			VueSelect
		},
		props: {
			dataTranslationList: {
				type: Array
			},
			dataGroups: {
				type: Array
			}
		},
		data() {
			return {
				translationList: this.dataTranslationList,
				groups: this.dataGroups,

				availableLanguages: this.$availableLanguages,
				isEditModalVisible: false,
				clickedLang: this.$defaultLanguage.locale,

				selectedTranslation: {
					id: null,
					key: null,
					group: null,
				},

				userRoles: this.$currentUserRoles,
				errors: new Errors(),
			}
		},
		created() {
			let vm = this;

			for (let i = 0; i < vm.$availableLanguages.length; i++) {
				vm.selectedTranslation[vm.$availableLanguages[i].locale] = {
					value: ''
				};
			}

			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});

		},
		methods: {
			editTranslation: function (translation) {
				let vm = this;

				vm.selectedTranslation = {
					id: translation.id,
					group: translation.group,
					key: translation.key
				};

				for (let i = 0; i < vm.$availableLanguages.length; i++) {
					vm.selectedTranslation[vm.$availableLanguages[i].locale] = {
						value: translation.translations.hasOwnProperty(vm.$availableLanguages[i].locale)
							? translation.translations[vm.$availableLanguages[i].locale].value : ''
					};
				}

				eventBus.$emit('pushActiveStatus', this.$defaultLanguage);
				this.clickedLang = this.$defaultLanguage.locale;
				vm.isEditModalVisible = true;
			},
			saveTranslation: function () {
				let vm = this;
				axios.put('/api/' + vm.$selectedSite.slug + '/translations/' + vm.selectedTranslation.id, vm.selectedTranslation)
					.then(response => {
						this.$toastr.success('Translation updated successfully.');
						window.location.reload();
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Save translation failed.', 'Error');
					});
			},
			deleteTranslation: function (translation) {
				let vm = this;

				this.$dialog.confirm('Are you sure you want to delete this translation?', {
					loader: true
				})
					.then((dialog) => {
						axios.delete('/api/' + vm.$selectedSite.slug + '/translations/' + translation.id,)
							.then(function () {
								dialog.close();
								vm.$toastr.success('Translation deleted successfully.');
								location.reload();
							})
							.catch(function () {
								dialog.close();
								vm.$toastr.error('Deleting translation failed.', 'Error');
							});
					})
					.catch(() => {
						this.$toastr.error('Delete aborted.');
					});

			},
			closeEditModal: function () {
				this.isEditModalVisible = false;
			},
		}
	}
</script>

<style scoped>

</style>
